<ng-template #content_lookup_edit let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.lookup">
        <div class="side_popup_header">
            <span>{{localService.languageContent.lookup.header}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
    </div>
    <div class="side_popup_body" style="margin: 10px;"
        [ngStyle]="{'height' : (localService.sideBarBodyHeight - 50) + 'px'}" *ngIf="wrapper">
        <div class="row">
            <div class="col-12">
                <app-label [Text]="localService.languageContent.lookup.code" />
                <input autocomplete="off" type="text" id="{{elementIds.code}}" class="en"
                    [(ngModel)]="wrapper.content.v1" placeholder="{{localService.languageContent.lookup.code}}"
                    title="{{localService.languageContent.lookup.code}}"
                    (keydown.enter)="localService.onFocusNextInput(elementIds.title, 1)" />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <app-language-container [MaxLength]="100" [Title]="localService.languageContent.lookup.title"
                    [(languageContents)]="wrapper.languageContents"
                    (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event,1)"
                    [IsPartiallyMandatory]="true" [id]="elementIds.title" [IsNeedNewLine]="true">
                </app-language-container>
            </div>
        </div>
    </div>
    <div class="side_popup_footer">
        <div class="row">
            <div class="col-8" style="text-align: left;">
                <span *ngIf="message != ''"
                    [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
            </div>
            <div class="col-4" style="text-align: right;">
                <button id="{{elementIds.save}}" type="button" class="btn btn-primary" (click)="onAction(2)">
                    {{id ? localService.languageContent.common.update :
                    localService.languageContent.common.create}}
                </button>
            </div>
        </div>
    </div>
</ng-template>